export default "__VITE_ASSET__HfhHP3Dj__"